
import React from "react";

interface ValuationErrorProps {
  errorMessage: string;
  onRefresh: () => void;
}

export function ValuationError({ errorMessage, onRefresh }: ValuationErrorProps) {
  return (
    <div className="p-4 bg-red-50 dark:bg-red-950/30 border border-red-200 dark:border-red-800 rounded-lg text-red-600 dark:text-red-400 text-sm">
      <p>{errorMessage}</p>
      <button 
        onClick={onRefresh} 
        className="text-xs underline mt-1 hover:text-red-800 dark:hover:text-red-300"
      >
        Aggiorna prezzi
      </button>
    </div>
  );
}
